// extracted by mini-css-extract-plugin
export default {"container":"container--FYUZh","logo":"logo--sNYR_","title":"title--IIEeG","headingContainer":"headingContainer--Bxesy col-xs-12 col-md-offset-3 col-md-6"};